import { useCallback, useEffect, useState } from 'react';
import { logger } from '@nykaa/logger';
import { CallbackParams, ObjectType } from 'types/PinxBox';


export const addWindowHandler = (callBack : (arg0: null | CallbackParams) => void) => {
    window.handleGamoogaPinkBoxNotification = (title: string, obj: ObjectType) => {
      if (typeof title !== 'string' && typeof obj !== 'object') {
        return;
      }
      const {
        GAMOOGA_NOTIFICATION_NOTIFICATION_DISPLAY_TIME_IN_SEC,
        GAMOOGA_NOTIFICATION_NOTIFICATION_ADDITIONAL_DISPLAY_TIME_IN_SEC,
        ...params
      } = obj;
      if (typeof callBack === 'function') {
        callBack({ title, params });
      }
      const milliSeconds = (Number(GAMOOGA_NOTIFICATION_NOTIFICATION_DISPLAY_TIME_IN_SEC)
        + Number(GAMOOGA_NOTIFICATION_NOTIFICATION_ADDITIONAL_DISPLAY_TIME_IN_SEC)) * 1000;
      setTimeout(() => {
        if (typeof callBack === 'function') {
          callBack(null);
        }
      }, milliSeconds);
    };
};


export const defaultPinkBoxData = {
  title: '',
  params: {
    GAMOOGA_NOTIFICATION_UTM_SOURCE: '',
    GAMOOGA_NOTIFICATION_UTM_MEDIUM: '',
    GAMOOGA_NOTIFICATION_UTM_CAMPAIGN: '',
    cp_id: '',
    description: '',
    button_text: '',
    redirect_url: '',
    font_size: 12,
    button_font_size: 13,
  },
};

export const usePinkBoxGamoogaData = () => {
  const [pinkboxData, setPinkboxData] = useState<null | CallbackParams>(defaultPinkBoxData);
  const addHandler = useCallback(() => {
    addWindowHandler((params) => {
      try {
        setPinkboxData(params);
      } catch (error) {
        logger.error(error, 'error in gamooga call back');
      }
    });
  }, []);
  useEffect(() => {
    addHandler();
  }, [addHandler]);
  return pinkboxData;
};
